import { SyncState } from './sync.state';

import { AllState } from 'store/state';

export const getSyncState = (state: AllState): SyncState => state.sync;
